import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ["bankName", "bankAddress", "iban", "bic", "zipCode", "City", "country", "meansOfPayment", "fileBase64"]

  connect() {
    super.connect();
    console.log('RibUploadController connected');

    // // Existing code for meansOfPayment
    // $(this.meansOfPaymentTarget).on('select2:select', function () {
    //   let event = new Event('change', { bubbles: true })
    //   this.dispatchEvent(event);
    // })

    document.addEventListener('rib:closeModal', (event) => {
      console.log('Closing modal after successful save');

      const modal = this.element.closest('.modal');
      if (modal) {
        $(modal).modal('hide'); // Bootstrap 4 way
      }
    });

    // Activer le bouton quand l'utilisateur remplit manuellement un champ texte ou sélectionne un fichier
    this.element.addEventListener('input', (event) => {
      this.checkFieldsAndEnableButton();
    });

    // Activer le bouton quand l'utilisateur change un select (ex: pays)
    this.element.addEventListener('change', (event) => {
      if (event.target.tagName === 'SELECT') {
        this.checkFieldsAndEnableButton();
      }
    });
  }

  // This runs when file is selected
  async extractBankInfo(event) {
    const fileUploadInputElement = event.target;
    const file = fileUploadInputElement.files[0]
    const profileId = fileUploadInputElement.dataset.profileId;

    console.log('File selected:', file);
    console.log('Profile ID:', profileId);

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];

    if (file && allowedTypes.includes(file.type)) {
      this.showLoading();
      try {
        // Convertir le fichier en base64 et le stocker dans le champ caché
        const base64Data = await this.fileToBase64(file);
        this.fileBase64Target.value = base64Data;

        console.log('File converted to base64, calling Reflex...');

        // Désactiver le bouton pendant le traitement
        this.disableSubmitButton();

        await this.stimulate('RibUploadReflex#extract', profileId);

        console.log('Reflex call completed');
      } catch (error) {
        console.error('Reflex error:', error);
        this.showError('Failed to process RIB file: ' + error.message);
      }
    } else if (file) {
      console.log('Unsupported file type:', file.type);
      this.showError('Type de fichier non supporté. Veuillez utiliser un PDF ou une image (JPG, PNG).');
    } else {
      console.log('No file selected');
    }
  }

  fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        // Retirer le préfixe "data:application/pdf;base64,"
        const base64 = reader.result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  // Lifecycle method: appelé après que le Reflex a terminé
  afterReflex(element, reflex, noop, reflexId) {
    console.log('Reflex completed, checking fields...');
    
    // Vérifier si tous les champs sont remplis et activer le bouton si c'est le cas
    this.checkFieldsAndEnableButton();
  }

  checkFieldsAndEnableButton(event) {
    console.log('Checking if all fields are filled...');
    const modal = this.element.closest('.modal');
    if (!modal) return;
    
    const inputs = modal.querySelectorAll('input[type="text"]');
    const submitButton = modal.querySelector('#change-rib-submit-button');
    
    if (!submitButton) return;
    
    let allFilled = true;

    // Vérifie si un fichier RIB a été sélectionné
    const fileInput = modal.querySelector('input[type="file"]');
    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
      allFilled = false;
    }

    // Vérifie si TOUS les champs texte sont remplis
    inputs.forEach(input => {
      if (!input.value || input.value.trim() === '') {
        allFilled = false;
      }
    });

    // Vérifie si TOUS les selects sont remplis (ex: pays)
    const selects = modal.querySelectorAll('select');
    selects.forEach(select => {
      if (!select.value || select.value.trim() === '') {
        allFilled = false;
      }
    });

    // Active le bouton seulement si TOUS les champs sont remplis
    submitButton.disabled = !allFilled;
    
    console.log('Fields check completed - all filled:', allFilled);
    console.log('Submit button disabled:', submitButton.disabled);
  }

  disableSubmitButton() {
    const submitButton = this.element.querySelector('#change-rib-submit-button');
    if (submitButton) {
      submitButton.disabled = true;
    }
  }

  enableSubmitButton() {
    const submitButton = this.element.querySelector('#change-rib-submit-button');
    if (submitButton) {
      submitButton.disabled = false;
    }
  }

  showLoading() {
    const bankFields = this.element.querySelector('#bank-fields');
    if (bankFields) {
      bankFields.innerHTML = `
        <div class="text-center py-5">
          <div class="spinner-border text-light" role="status" style="width: 3rem; height: 3rem;">
            <span class="sr-only">Chargement...</span>
          </div>
          <p class="mt-3 text-light">Extraction des informations bancaires en cours...</p>
        </div>
      `;
    }
  }

  showError(message) {
    alert(message)
  }
}